import { forwardRef } from 'react';
import { makeStyles } from 'tss-react/mui';
import Chip from '@mui/material/Chip';
import { red, orange } from '@mui/material/colors';

const useStyles = makeStyles()((theme) => ({
  tag: {
    '& > span': {
      display: 'inline-flex',
      alignItems: 'center',
      '& > .MuiSvgIcon-root': {
        marginRight: theme.spacing(0.5),
        fontSize: 20,
      },
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
  },
  secondary: {
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff',
  },
  red: {
    backgroundColor: red[600],
    color: '#fff',
  },
  orange: {
    backgroundColor: orange[600],
    color: '#fff',
  },
}));

type Props = {
  children?: React.ReactNode;
  color?: string;
  className?: string;
  component?: React.ElementType;
  title?: string;
  variant?: 'filled' | 'outlined';
  href?: string;
};

const Tag = forwardRef<HTMLDivElement, Props>(({ children, color = null, className, ...otherProps }, ref) => {
  const { classes, cx } = useStyles();

  return (
    <Chip
      ref={ref}
      className={cx(classes.tag, classes[color], className)}
      size="small"
      {...otherProps}
      label={children}
    />
  );
});

Tag.displayName = 'Tag';

export default Tag;
